// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__6p50a","imageUploader":"EGiftCard_imageUploader__2vQmq"};